/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var app      = require('mag-app'),
    systemPlayer = require('../system.player'),
    isoLangs = require('cjs-iso-639'),
    optionsData = [];

function makeItem ( icon, text ) {
    return  [
        {
            className: icon
        },
        {
            value: text
        }
    ];
}

function setMuteHandler ( value ) {
    if ( core.plugins.settingsAudio ) {
        core.plugins.settingsAudio.mute = value;
    }
}

function setVolumeHandler ( value ) {
    if ( core.plugins.settingsAudio ) {
        core.plugins.settingsAudio.volume = value;
    }
}

function setAudiotrackHandler ( value ) {
    systemPlayer.primary.audioPID = value;
}

// add sound option only on MAG devices
if ( PLATFORM === 'MAG' ) {
    if ( app.config.disableSoundOptions.indexOf(core.device.model) < 0 ) {
        optionsData.push(
            {
                items: makeItem('theme-icon theme-icon-volume', gettext('Mute')),
                options: [
                    {
                        title: gettext('Mute On'),
                        value: true
                    },
                    {
                        title: gettext('Mute off'),
                        value: false
                    }
                ],
                handler: setMuteHandler,
                description: gettext('Mute all sound')
            }
        );


        optionsData.push(
            {
                items: makeItem('theme-icon theme-icon-volume', gettext('Volume level')),
                options: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(function ( value ) {
                    return {
                        value: value * 10,
                        title: (value * 10).toString()
                    };
                }),
                getFocusIndex: function () {
                    return parseInt(app.audioManager.list[0].volume / 10, 10);
                },
                handler: setVolumeHandler,
                description: gettext('Change volume level')
            }
        );
    }
}


optionsData.push(
    {
        items: makeItem('theme-icon theme-icon-subtitles', gettext('Sound track')),
        description: gettext('Change audio track language'),
        getFocusIndex: function () {
            var index,
                currentPid = systemPlayer.primary.audioPID;

            if ( systemPlayer.primary.audioTracks.length < 1) {
                return 0;
            }

            for ( index = 0; index < systemPlayer.primary.audioTracks.length; index++ ) {
                if ( systemPlayer.primary.audioTracks[index].pid === currentPid ) {
                    return index;
                }
            }

            return 0;
        },
        getOptions: function () {
            var result = [];

            systemPlayer.primary.audioTracks.forEach(function ( track ) {
                var title;

                if ( track.lang && track.lang.length && track.lang[0] !== 'und' ) {
                    title = track.lang[0];
                    title = isoLangs['1'][title] || isoLangs['2T'][title] || isoLangs['2B'][title] || [''];
                    title = title[0];
                } else {
                    title = gettext('Track') + ' ' + track.pid;
                }

                result.push({
                    value: track.pid,
                    title: title
                });
            });

            return result;
        },
        handler: setAudiotrackHandler
    }
);

module.exports = optionsData;
